export default __webpack_public_path__ + "static/media/WEX.ab776075.svg";